module.exports = __webpack_public_path__ + "static/img/doc_condominio.45acf03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doc_condominio.jpg
// module id = 2czj
// module chunks = 1